import { Button } from "react-aria-components";
import skill from "@/assets/figma/merchant-home/skill.svg";
import newChat from "@/assets/figma/merchant-home/new-chat.svg";
import { MerryButton } from "@/shared/ui/MerryButton";
import { HomeIcon } from "../ui/MerchantHomePrimitives";
import { safeMediaURL, workbenchSourceStatusView } from "../merchantHomePresentation";
import { monitorCardSummary } from "../merchantHomeMonitorPresentation";
import type { WorkbenchAction, WorkbenchContent, WorkbenchGroup } from "./contentSchemas";
import type { WorkbenchCatalogCard, WorkbenchItem } from "./layoutSchemas";
import { WorkbenchCardSections } from "./WorkbenchCardSections";
import { workbenchStateTitle } from "./workbenchStateTitle";

interface Props {
  item: WorkbenchItem;
  catalog: WorkbenchCatalogCard;
  group?: WorkbenchGroup;
  current?: WorkbenchContent;
  timezone: string;
  loading: boolean;
  error: boolean;
  errorCode?: string;
  onRetry: () => void;
  onAction: (action: WorkbenchAction) => void;
}

export function WorkbenchCardBody({ item, catalog, group, current, timezone, loading, error, errorCode, onRetry, onAction }: Props) {
  const sourceStatus = current ? workbenchSourceStatusView(current.source_status, timezone) : undefined;
  const objects = current?.sections.find(section => section.kind === "objects");
  const summary = current ? monitorCardSummary(current.card_type, current.state, current.summary, objects?.data?.object_count) : "";
  const action = current?.actions.find(candidate => candidate.enabled);

  return <>
    <div className="workbench-card__category"><span>{catalog.title}{sourceStatus?.asOf ? ` · 来源时间 ${sourceStatus.asOf}` : ""}</span><span>{error ? (errorCode ?? "读取失败") : (group?.effective_scope.market || "待选市场")}</span></div>
    <div className="workbench-card__scroll">
      {error ? <div className="workbench-card__state" role="alert"><strong>资料暂时无法读取</strong>{errorCode ? <p><code>{errorCode}</code></p> : null}<MerryButton size={34} hierarchy="level2" onPress={onRetry}>重新读取资料</MerryButton></div> : loading ? <div className="workbench-card__state" role="status">正在读取{catalog.title}…</div> : current ? <>
        <div className="workbench-card__heading">{current.media?.media_type === "image" && item.card_type !== "media_reference" && safeMediaURL(current.media.public_url) ? <img className="workbench-card__thumbnail" src={safeMediaURL(current.media.public_url)} alt={current.title} /> : <HomeIcon src={skill} />}<div><h3>{current.title}</h3>{sourceStatus && <div className="workbench-card__source-status"><span>{sourceStatus.freshnessLabel}</span><span>{sourceStatus.coverageLabel}</span>{sourceStatus.syncHealthLabel && <span>{sourceStatus.syncHealthLabel}</span>}</div>}</div>{action && <Button className="workbench-inline-action" aria-label={`${action.label}：${current.title}`} onPress={() => onAction(action)}><HomeIcon src={newChat} /></Button>}</div>
        {current.state !== "ready" ? <div className="workbench-card__state" role={current.state === "error" ? "alert" : "status"}><strong>{workbenchStateTitle(current.state, current.error_code)}</strong><p>{current.summary}</p></div> : <>
          {summary && <p className="workbench-card__summary">{summary}</p>}
          <WorkbenchCardSections item={item} catalog={catalog} content={current} timezone={timezone} />
        </>}
      </> : <div className="workbench-card__state"><strong>暂无相关资料</strong><p>有新的已发布资料时，会在这里展示。</p></div>}
    </div>
  </>;
}
